import loadable from '@loadable/component';

export const CmsDownloadButtonLoadable = loadable(
  () => import('./CmsDownloadButton'),
  { resolveComponent: (module) => module.CmsDownloadButton },
);
